(function($, undefined) {
	
	"use strict";
	
	window.addEventListener('beforeunload', function() {
		window.parent.window.postMessage('iframe_before_unloading', '*');
	});
	window.addEventListener('unload', function() {
		window.parent.window.postMessage('iframe_unloading', '*');
	});
	
})(jQuery);